export default [
  {
    path: "*",
    meta: {
      public: true
    },
    redirect: {
      path: "/404"
    }
  },
  {
    path: "/404",
    meta: {
      public: true
    },
    name: "NotFound",
    component: () => import(`@/views/NotFound.vue`)
  },
  {
    path: "/403",
    meta: {
      public: true
    },
    name: "AccessDenied",
    component: () => import(`@/views/Deny.vue`)
  },
  {
    path: "/500",
    meta: {
      public: true
    },
    name: "ServerError",
    component: () => import(`@/views/Error.vue`)
  },
  {
    path: "/login",
    meta: {
      public: true
    },
    name: "Login",
    component: () => import(`@/views/Login.vue`)
  },
  {
    path: "/usuarios",
    name: "Usuarios",
    meta: { breadcrumb: true },
    component: () => import(`@/components/l6s/usuarios/grid-usuarios.vue`)
  },
  {
    path: "/usuarios/novo",
    name: "NovoUsuario",
    meta: { breadcrumb: true },
    component: () => import(`@/components/l6s/usuarios/cadastro/usuario.vue`)
  },
  {
    path: "/usuarios/editar/:id",
    name: "EditarUsuario",
    meta: { breadcrumb: true },
    component: () => import(`@/components/l6s/usuarios/cadastro/usuario.vue`)
  },
  {
    path: "/clientes",
    name: "Clientes",
    meta: { breadcrumb: true },
    component: () => import(`@/components/l6s/clientes/grid-clientes.vue`)
  },
  {
    path: "/clientes/novo",
    name: "NovoCliente",
    meta: { breadcrumb: true },
    component: () => import(`@/components/l6s/clientes/cadastro/cliente.vue`)
  },
  {
    path: "/clientes/editar/:id",
    name: "EditarCliente",
    meta: { breadcrumb: true },
    component: () => import(`@/components/l6s/clientes/cadastro/cliente.vue`)
  },
  {
    path: "/projetos",
    name: "Projetos",
    meta: { breadcrumb: true },
    component: () => import(`@/components/l6s/projetos/grid-projetos.vue`)
  },
  {
    path: "/projetos/novo",
    name: "NovoProjeto",
    meta: { breadcrumb: true },
    component: () => import(`@/components/l6s/projetos/cadastro/projeto.vue`)
  },
  {
    path: "/projetos/editar/:id",
    name: "EditarProjeto",
    meta: { breadcrumb: true },
    component: () => import(`@/components/l6s/projetos/cadastro/projeto.vue`)
  },
  {
    path: "/projetos/imprimir-calendario/:id",
    name: "ImprimirCalendarioDoProjeto",
    meta: { breadcrumb: false },
    component: () =>
      import(
        `@/components/l6s/projetos/impressao-de-calendario/impressaoDeCalendarioDoProjeto.vue`
      )
  },
  {
    path: "/atividades",
    name: "Atividades",
    meta: { breadcrumb: true },
    component: () => import(`@/components/l6s/atividades/grid-atividades.vue`)
  },
  {
    path: "/atividades/novo",
    name: "NovaAtividade",
    meta: { breadcrumb: true },
    component: () =>
      import(`@/components/l6s/atividades/cadastro/atividade.vue`)
  },
  {
    path: "/atividades/editar/:id",
    name: "EditarAtividade",
    meta: { breadcrumb: true },
    component: () =>
      import(`@/components/l6s/atividades/cadastro/atividade.vue`)
  },
  {
    path: "/setores",
    name: "Setores",
    meta: { breadcrumb: true },
    component: () => import(`@/components/l6s/setores/grid-setores.vue`)
  },
  {
    path: "/setores/novo",
    name: "NovoSetor",
    meta: { breadcrumb: true },
    component: () => import(`@/components/l6s/setores/cadastro/setor.vue`)
  },
  {
    path: "/setores/editar/:id",
    name: "EditarSetor",
    meta: { breadcrumb: true },
    component: () => import(`@/components/l6s/setores/cadastro/setor.vue`)
  },
  {
    path: "/apontamentos",
    name: "Apontamentos",
    meta: { breadcrumb: true },
    component: () =>
      import(`@/components/l6s/apontamentos/grid-apontamentos.vue`)
  },
  {
    path: "/apontamentos/novo",
    name: "NovoApontamento",
    meta: { breadcrumb: true },
    component: () =>
      import(`@/components/l6s/apontamentos/cadastro/apontamento.vue`)
  },
  {
    path: "/apontamentos/editar/:id",
    name: "EditarApontamento",
    meta: { breadcrumb: true },
    component: () =>
      import(`@/components/l6s/apontamentos/cadastro/apontamento.vue`)
  },
  {
    path: "/consulta-apontamentos",
    name: "ConsultaApontamentos",
    meta: { breadcrumb: false },
    component: () =>
      import(`@/components/l6s/apontamentos/consulta/consulta-apontamentos.vue`)
  },
  {
    path: "/",
    meta: {},
    name: "Root",
    redirect: {
      name: "Apontamentos"
    }
  },
  {
    path: "/dashboard",
    meta: {},
    name: "Dashboard",
    redirect: {
      name: "Apontamentos"
    }
  }
];
